<div class="instagram-settings" [formGroup]="form">
  <div class="instagram-settings__field">
    <label class="instagram-settings__label">Post type</label>
    <icn-dropdown
      class="instagram-settings__dropdown"
      [large]="true"
      [allowMultiple]="false"
      [listDown]="true"
      [disabled]="readonly"
      [selectedValue]="form.controls.defaultPostType.value"
      (selectedValueChange)="onPostTypeChange($event)"
    >
      <icn-dropdown-item
        *ngFor="let option of instagramPostTypes"
        [value]="option.value"
        [title]="option.label"
      ></icn-dropdown-item>
    </icn-dropdown>
  </div>

  <div class="instagram-settings__field instagram-settings__field--row">
    <mat-checkbox
      formControlName="shareToFeed"
      class="instagram-settings__checkbox"
      [disableRipple]="true"
    >
      Share to feed
    </mat-checkbox>
    <span
      class="instagram-settings__field-help"
      tabindex="0"
      aria-label="Share to feed setting information"
    >
      ?
      <span class="instagram-settings__field-tooltip">
        {{ shareToFeedTooltip }}
      </span>
    </span>
  </div>

  <div class="instagram-settings__field">
    <mat-checkbox
      formControlName="isAiGenerated"
      class="instagram-settings__checkbox"
      [disableRipple]="true"
    >
      AI-generated content
    </mat-checkbox>
  </div>
</div>
